import { Box, Container, Typography } from "@mui/material";

import Grid from "@mui/material/Grid2";
export default function HeaderBanner() {
  return (
    <Box
      sx={{
        backgroundColor: "#f5f5f5",
        pt: 1,
      }}
    >
      <Container>
        <Grid container alignItems="center">
          <Grid size={{ xs: 12, md: 2 }}>
            <Box
              component="img"
              src="logotb.jpeg"
              alt="Left Logo"
              sx={{
                width: { xs: 50, md: 80 },
                display: "block",
                mx: { xs: "auto", md: "auto" },
              }}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 8 }}>
            <Box textAlign="center">
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 400,
                  color: "#006b3f",
                  lineHeight: 1.1,
                  fontSize: { xs: "28px", md: "28px" },
                }}
              >
                Hayatabad Medical Complex
              </Typography>

              <Typography
                variant="h3"
                sx={{
                  fontWeight: 700,
                  color: "#006b3f",
                  lineHeight: 1.1,
                  fontSize: { xs: "28px", md: "32px" },
                }}
              >
                Provincial TB Control Program
              </Typography>
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 2 }}>
            <Box
              component="img"
              src="kp_logo.png"
              alt="Right Logo"
              sx={{
                width: { xs: 50, md: 80 },
                display: "block",
                ml: { md: "auto" },
                mx: { xs: "auto", md: "auto" },
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
